import { useEffect } from "react";

import {
  Navigate,
  Outlet,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";

import { MenuItems } from "../../utils/constants";
import { getCurrentUser } from "../../utils/utils";

const DefaultLayout = () => {
  const navigate = useNavigate();
  const user = getCurrentUser();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (location?.state && location.state?.redirect) {
      setSearchParams(`?redirect=${location.state.redirect}`);
    }
  }, [location]);

  if (user) {
    if (
      Date.parse(user.accessTokenExpire) > new Date().getTime() ||
      Date.parse(user.refreshTokenExpire) > new Date().getTime()
    ) {
      return <Navigate to="/employments" />;
    }
  }

  return (
    <Container style={{ maxWidth: "100%" }}>
      <Row>
        <Navbar collapseOnSelect expand="lg" className="header-menu">
          <Container>
            <Navbar.Brand onClick={() => navigate("/")} className="text-white">
              ready.ninja
            </Navbar.Brand>
            <Navbar.Toggle
              aria-controls="responsive-navbar-nav"
              className="bg-white"
            />
            <Navbar.Collapse id="responsive-navbar-nav">
              <Nav className="me-auto">
                {MenuItems.map((item) => (
                  <Nav.Link key={item.path} onClick={() => navigate(item.path)}>
                    {item.label}
                  </Nav.Link>
                ))}
              </Nav>
              <Nav>
                <Nav.Link
                  onClick={() => navigate("/login")}
                  className="text-white"
                >
                  Login
                </Nav.Link>
                <Nav.Link
                  onClick={() => navigate("/register")}
                  className="text-white"
                >
                  Register
                </Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </Row>
      <Row className="mobile-layout-background">
        <div
          className="outlet bg-white rounded-2 pt-4 pb-4"
          style={{ boxShadow: "0px 0px 15px 5px rgba(0, 0, 0, 0.25)" }}
        >
          <Outlet />
        </div>
      </Row>
    </Container>
  );
};

export default DefaultLayout;
